import { api } from '@/api/ApiGateway'

class ScheduledReportsApi
{
	/**
	 * Immediately run a report
	 * @param p_report_id {number} Id of the report to run
	 * @param p_settings {Object} Object of report settings
	 * @param p_recipient_ids {Array<{ "id": number }>}
	 * @param p_on_complete {function} Callback function
	 */
	runReport(p_report_id, p_settings, p_recipient_ids, p_on_complete)
	{
		api.post('scheduled-reports/admin/run', {'report_data':{
			id: p_report_id,
			settings: p_settings,
			recipient_ids: p_recipient_ids
		}}).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, true)
				return
			}

			p_on_complete(p_response, false)

		})
	}

	/**
	 * Enable a report
	 * @param report_id {number} Report id
	 * @param p_on_complete {function} Callback function
	 */
	enableReport(report_id, p_on_complete)
	{
		api.patch(`scheduled-reports/admin/${report_id}/enable`).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, 'edit', true)
				return
			}

			p_on_complete(p_response, 'edit', false)
		})
	}

	/**
	 * Disable a report
	 * @param report_id {number} Report id
	 * @param p_on_complete {function} Callback function
	 */
	disableReport(report_id, p_on_complete)
	{
		api.patch(`scheduled-reports/admin/${report_id}/disable`).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, 'edit', true)
				return
			}

			p_on_complete(p_response, 'edit', false)
		})
	}

	/**
	 * Create a report
	 * @param p_data {Object} Report data
	 * @param p_on_complete {function} Callback function
	 */
	createReport(p_data, p_on_complete)
	{
		api.post(`scheduled-reports/admin/create`, { 'report_data': p_data }).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, 'duplicate', true)
				return
			}

			p_on_complete(p_response, 'duplicate', false)
		})
	}

	/**
	 * Modify a report
	 * @param p_data {Object} Report data
	 * @param p_on_complete {function} Callback function
	 */
	updateReport(p_data, p_on_complete)
	{
		api.patch(`scheduled-reports/admin/${p_data.id}/update`, { 'report_data': p_data }).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, 'edit', true)
				return
			}

			p_on_complete(p_response, 'edit', false)
		})
	}

	/**
	 * Modify a report
	 * @param p_data {Object} Report data
	 * @param p_on_complete {function} Callback function
	 */
	deleteReport(p_data, p_on_complete)
	{
		api.delete(`scheduled-reports/admin/${p_data.id}/delete`, { 'deletion_data': p_data }).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, 'delete', true)
				return
			}

			p_on_complete(p_response, 'delete', false)
		})
	}

	/**
	 * Update the scheduled report settings for the tenant
 	 * @param p_settings {Object} Full settings object under scheduled_reports.value tenant setting
	 * @param p_on_complete {function} Callback function
	 */
	updateTenantSettings(p_settings, p_on_complete) {
		api.post(`scheduled-reports/admin/tenant-settings`, { 'report_settings': p_settings }).then(p_response => {
			if (p_response.hasError())
			{
				p_on_complete(p_response, true)
				return
			}
			p_on_complete(p_response, false)
		})
	}
}


export const scheduledReportsApi = new ScheduledReportsApi()